import React, { useState, useEffect } from 'react'
import {
    Modal,
    Form,
    Input,
    Row,
    Col,
    Button,
    message
} from 'antd'
import { getLadderRefundDetail, confirmCost } from '../../api'
import { getPlateBalances }　from '../../../../../api/api'

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 8 }
}
const ConfrimRefund = (props) => {
    const { visible, close, backNo, refresh } = props
    const [form] = Form.useForm()
    const [serviceConfigVoList, setServiceConfigVoList] = useState({})
    const [code, setCode] = useState()
    const [showTip, setShowTip] = useState(false)
    const [confirmLoading, setConfrimLoading] = useState(false)

    const initialFormValues = {
        companyCodeName: '',
        month: '',
        commissionAmount: '',
        alreadyServiceAmount: '',
        shouldServiceAmount: '',
        backAmount: '',
        backCostTime: '',
        backCostUser: '',
        balances: '',
        platformPhone: ''
    }
    
    // 获取余额
    const getBalances = async() => {
        try {
            const res = await getPlateBalances()
            form.setFieldsValue({
                balances: res.serviceBalancesVo.balancesVo.actualBal
            })
        } catch(err) {
            console.log(err)
        }
    }
    // 获取详情
    const getDetail = async(backNo) => {
        console.log(backNo)
        try {
           const res = await getLadderRefundDetail({backNo: backNo})
            if (res.data.success) {
               console.log(res.data)
               form.setFieldsValue({
                    companyCodeName: res.data.data.companyCodeName,
                    month: res.data.data.month,
                    commissionAmount: res.data.data.commissionAmount,
                    alreadyServiceAmount: res.data.data.alreadyServiceAmount,
                    shouldServiceAmount: res.data.data.shouldServiceAmount,
                    backAmount: res.data.data.backAmount,
                    backCostTime: res.data.data.backCostTime,
                    backCostUser: res.data.data.backCostUser,
                    platformPhone: res.data.data.platformPhone
                })
                setServiceConfigVoList(res.data.data.serviceConfigVoList)
            }
        } catch(err) {
            console.log(err)
        }
    }
    useEffect(() => {
        if (visible) {
           getDetail(backNo)
           getBalances()
        }
    }, [visible, backNo])

    const codeChange = (e) => {
        console.log(e.target.value)
        setCode(e.target.value)
    }

    const onCancel = () => {
        close()
        setShowTip(false)
        form.resetFields()
        setServiceConfigVoList({})
    }
    const onOk = async() => {
        const { balances, backAmount } = form.getFieldsValue()
        if (balances < backAmount) {
            setShowTip(true)
        } else {
            try {
                setConfrimLoading(true)
                const res = await confirmCost({backNo: backNo})
                console.log(res)
                if (res.data.success) {
                    message.success('退费成功')
                    close()
                    refresh()
                } else {
                    message.error(res.data.retMsg)
                }
                setConfrimLoading(false)
            } catch(err) {
                setConfrimLoading(false)
                console.log('__确认退费', err)
            }
        }
    }
    return (
        <Modal maskClosable={false} title="查看" confirmLoading={confirmLoading} visible={visible} onOk={onOk} onCancel={onCancel}  width={840}>
            <Form form={form} {...formItemLayout} initialValues={initialFormValues}>
                <Form.Item label="企业名称" name="companyCodeName">
                    <Input disabled></Input>
                </Form.Item>
                <Form.Item label="自然月" name="month">
                    <Input disabled></Input>
                </Form.Item>
                <Form.Item label="常规服务费收取规则" wrapperCol={{span: 18}}>
                {serviceConfigVoList && serviceConfigVoList.length > 0 && serviceConfigVoList.map(item => (
                    <div key={item.planType}>
                        {item.planType === 1 && <div className="sub-title">临时税务登记</div>}
                        {item.planType === 2 && <div className="sub-title">个体工商户</div>}
                        <div className="box-row">
                            <div>
                                {item.serviceLadderFlag === 1 && 
                                    <>
                                        <p>阶梯式</p>
                                        {
                                        item.companyConfigDetailList && item.companyConfigDetailList.map(p=>
                                            <p key={p.sort}>第{p.sort}阶段：{p.minAmount}≤当月（自然月）累计批量佣金金额 &lt; {p.maxAmount}万时，单笔佣金的{item.serviceType === 1 ? '固定金额' : '百分比'}，每笔{p.value}{item.serviceType === 1 ? '元' : '%'}</p>
                                        )
                                        }
                                        
                                    </>
                                }
                                {item.serviceLadderFlag === 0 && 
                                    <>
                                        <p>非阶梯</p>
                                        <p>{item.serviceType === 1 ? '单笔佣金的固定金额' : '单笔佣金的百分比'}, 每笔{item.serviceValue}{item.serviceType === 1 ? '元' : '%'}</p>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                ))}
                </Form.Item>
                <Form.Item label="佣金流水" name="commissionAmount">
                    <Input disabled></Input>
                </Form.Item>
                <Form.Item label="已收常规服务费" name="alreadyServiceAmount">
                    <Input disabled></Input>
                </Form.Item>
                <Form.Item label="应收取的常规服务费" name="shouldServiceAmount">
                    <Input disabled></Input>
                </Form.Item>
                <Row>
                    <Col span={12}>
                        <Form.Item labelCol={{span: 8}} wrapperCol={{span: 16}} label="服务费子户余额" name="balances">
                            <Input disabled></Input>
                        </Form.Item>
                    </Col>
                    <Col>
                        {
                            showTip && <span style={{color: 'red', marginLeft: '10px'}}>子户余额不足，请充值后再操作退费</span>
                        }
                        
                    </Col>
                </Row>
                
                <Form.Item label="退还服务费" name="backAmount">
                    <Input disabled></Input>
                </Form.Item>
                <Form.Item label="平台手机号" name="platformPhone">
                    <Input disabled></Input>
                </Form.Item>
                <Row>
                    <Col span={12}>
                        <Form.Item labelCol={{span: 8}} wrapperCol={{span: 16}} label="短信验证码">
                            <Input value={code} onChange={(e) => codeChange(e)}></Input>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Button>获取验证码</Button>
                    </Col>
                </Row>
                
            </Form>
        </Modal>
    )
}

export default ConfrimRefund